import { render, staticRenderFns } from "./rowTem.vue?vue&type=template&id=242f34a0&scoped=true&"
import script from "./rowTem.vue?vue&type=script&lang=js&"
export * from "./rowTem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f34a0",
  null
  
)

export default component.exports